export enum ObjectLinkDependencyTypes {
  No_Link = 0,
  Upstream = 1,
  Downstream = 2,
}
